import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + "/general/admin/vending";
  // return "http://192.168.1.12:3003/general/admin/vending";
};

export const vendingbaseURL = () => {
  return APIHost() + "/admin/vending";
};

export const vendingbaseURL2 = () => {
  return APIHost() + "/vending/admin";
};

export const loadVendingCategory = data => {
  const url = `${baseURL()}/category/load`;
  return axios.post(url, data);
};

export const addVendingCategory = data => {
  const url = `${baseURL()}/category/create`;
  return axios.post(url, data);
};

export const editVendingCategory = (id, data) => {
  const url = `${baseURL()}/category/update/${id}`;
  return axios.post(url, data);
};

export const deleteVendingCategory = (id, data) => {
  const url = `${baseURL()}/category/remove/${id}`;
  return axios.post(url, data);
};


export const loadVendingCategoryEffectiveDateList = (data) => {
  const url = `${baseURL()}/price/effectiveDate`;
  return axios.post(url, data);
};

export const vendingCategoryPriceControlLoad = (data) => {
  const url = `${baseURL()}/priceControl/load`;
  return axios.post(url, data);
};

export const vendingCategoryPriceControlSet = (id, data) => {
  const url = `${baseURL()}/priceControl/set/${id}`;  
  return axios.post(url, data);
};

export const vendingCategoryPriceRemove = (id, data) => {
  const url = `${baseURL()}/priceControl/remove/${id}`;
  return axios.post(url, data);
};

export const getVendingCategoryPricePDF = data => {
  const url = `${baseURL()}/price/pdf `;
  return axios.post(url, data);
};


/** Grader Vending **/
export const loadGraderVendingList = data => {
  const url = `${vendingbaseURL()}/load`;
  return axios.post(url, data);
};

export const loadGraderVendingLocationList = data => {
  const url = `${vendingbaseURL()}/location/load`;
  return axios.post(url, data);
};

export const loadGraderVendingBagList = (data) => {
  const url = `${vendingbaseURL()}/bag/load`;
  return axios.post(url, data);
};

export const vendingBagCount = (data) => {
  const url = `${vendingbaseURL()}/bag/count`;
  return axios.post(url, data);
};

export const vendingBagRollbackOverflow = (id, data) => {
  const url = `${vendingbaseURL()}/bag/rollbackOverflow/${id}`;
  return axios.post(url, data);
};

export const vendingBagConfirmTripFilling = (id, data) => {
  const url = `${vendingbaseURL()}/bag/confirmTripFilling/${id}`;
  return axios.post(url, data);
};

export const vendingBagForceTripFilling = (id, data) => {
  const url = `${vendingbaseURL()}/bag/forceTripFilling/${id}`;
  return axios.post(url, data);
};

export const graderVendingDeviceStatusList = (id, data) => {
  const url = `${vendingbaseURL()}/deviceStatus/${id}`;
  return axios.post(url, data);
};

export const graderVendingUploadedLogsList = (data) => {
  const url = `${vendingbaseURL()}/logs`;
  return axios.post(url, data);
};

export const errorLogsResolved = (id, data) => {
  const url = `${vendingbaseURL()}/logs/resovle/${id}`;
  return axios.post(url, data);
};

export const graderVendingDetail = (id, data) => {
  const url = `${vendingbaseURL()}/detail/${id}`;
  return axios.post(url, data);
};

export const graderVendingCount = (data) => {
  const url = `${vendingbaseURL()}/count`;
  return axios.post(url, data);
};

export const approveGraderVending = (id, data) => {
  const url = `${vendingbaseURL()}/approve/${id}`;
  return axios.post(url, data);
};

export const addGraderVending = (grader, data) => {
  const url = `${vendingbaseURL()}/create/${grader}`;
  return axios.post(url, data);
};

export const editGraderVending =  (id, grader, data) => {
  const url = `${vendingbaseURL()}/update/${id}/${grader}`;
  return axios.post(url, data);
};

export const resetPwdGraderVending =  (id, grader, data) => {
  const url = `${vendingbaseURL()}/resetPwd/${id}/${grader}`;
  return axios.post(url, data);
};

export const deleteGraderVending = (id, grader, data) => {
  const url = `${vendingbaseURL()}/remove/${id}/${grader}`;
  return axios.post(url, data);
};

export const publishGraderVending = (id, grader, data) => {
  const url = `${vendingbaseURL()}/publish/${id}/${grader}`;
  return axios.post(url, data);
};

export const residentOnlyGraderVending = (id, grader, data) => {
  const url = `${vendingbaseURL()}/residentOnly/${id}/${grader}`;
  return axios.post(url, data);
};

export const rebootGraderVending = (id, data) => {
  const url = `${vendingbaseURL2()}/reboot/${id}`;
  return axios.post(url, data);
};

export const unlockMaglockGraderVending = (id, data) => {
  const url = `${vendingbaseURL2()}/unlockMaglock/${id}`;
  return axios.post(url, data);
};

export const currentStatusGraderVending = (id, data) => {
  const url = `${vendingbaseURL2()}/currentStatus/${id}`;
  return axios.post(url, data);
};

// command: "light/on" | "light/off" | "lid/open" | "lid/close"
export const controlBoardGraderVending = (id, command, data) => {
  const url = `${vendingbaseURL2()}/${command}/${id}`;
  return axios.post(url, data);
};

export const currentWeightGraderVending = (id, data) => {
  const url = `${vendingbaseURL2()}/currentWeight/${id}`;
  return axios.post(url, data);
};

export const currentSnapshotGraderVending = (id, data) => {
  const url = `${vendingbaseURL2()}/currentSnapshot/${id}`;
  return axios.post(url, data);
};

export const stopGraderVending = (id, data) => {
  const url = `${vendingbaseURL2()}/stop/${id}`;
  return axios.post(url, data);
};

export const startGraderVending = (id, data) => {
  const url = `${vendingbaseURL2()}/start/${id}`;
  return axios.post(url, data);
};

export const testConnectionGraderVending = (id, data) => {
  const url = `${vendingbaseURL2()}/testConnection/${id}`;
  return axios.post(url, data);
};

export const vendingLandfillDistance = (id, data) => {
  const url = `${vendingbaseURL()}/landfillDistance/${id}`;
  return axios.post(url, data);
};

export const audioTTList = (data) => {
  const url = `${vendingbaseURL()}/audioTTS/load`;
  return axios.post(url, data);
};

export const audioTTSUpdate = (data) => {
  const url = `${vendingbaseURL2()}/audioTTS/update`;
  return axios.post(url, data);
};

export const resetMQTTTopic = (data) => {
  const url = `${vendingbaseURL2()}/express/MQTTReset`;
  return axios.post(url, data);
};

export const cancelStuckExpressOrder = (id, data) => {
  const url = `${vendingbaseURL2()}/express/stuck/cancel/${id}`;
  return axios.post(url, data);
};
/** END Grader Vending **/


/* ===== DRVM DASHBOARD===== */
export const loadDRVMGradingOrderDashboard = data => {
  const url = `${vendingbaseURL()}/dashboard/order`;
  return axios.post(url, data);
};

export const loadDRVMGradingVendingDashboard = data => {
  const url = `${vendingbaseURL()}/dashboard/vending`;
  return axios.post(url, data);
};
  
export const loadDRVMGradingStatusChart = data => {
  const url = `${vendingbaseURL()}/dashboard/status/chart`;
  return axios.post(url, data);
};

export const loadDRVMGradingOrderChart = data => {
  const url = `${vendingbaseURL()}/dashboard/order/chart`;
  return axios.post(url, data);
};

export const loadDRVMGradingRanking = data => {
  const url = `${vendingbaseURL()}/dashboard/ranking`;
  return axios.post(url, data);
};

export const loadDRVMGradingCategoryChart = data => {
  const url = `${vendingbaseURL()}/dashboard/category/chart`;
  return axios.post(url, data);
};
/* ===== END DRVM DASHBOARD===== */


/* ===== VENDING COUNCIL ===== */
export const vendingCouncilList = data => {
  const url = `${vendingbaseURL()}/council/list`;
  return axios.post(url, data);
};

export const vendingCouncilCreate = data => {
  const url = `${vendingbaseURL()}/council/create`;
  return axios.post(url, data);
};

export const vendingCouncilUpdate = (id, data) => {
  const url = `${vendingbaseURL()}/council/update/${id}`;
  return axios.post(url, data);
};

export const vendingCouncilRemove = (id, data) => {
  const url = `${vendingbaseURL()}/council/remove/${id}`;
  return axios.post(url, data);
};

export const vendingCouncilSet = data => {
  const url = `${vendingbaseURL()}/council/set`;
  return axios.post(url, data);
};
/* ===== END VENDING COUNCIL ===== */


/* ===== VENDING VERSION ===== */
export const vendingVersionList = data => {
  const url = `${vendingbaseURL()}/version/load`;
  return axios.post(url, data);
};

export const vendingVersionUpload = (data, onUploadProgress) => {
  const url = `${vendingbaseURL()}/version/upload`;
  // APK up to 500MB - disable default 25s timeout
  return axios.post(url, data, { onUploadProgress, timeout: 0 });
};

export const vendingVersionSelect = (id, data) => {
  const url = `${vendingbaseURL2()}/version/select/${id}`;
  return axios.post(url, data);
};

export const vendingVersionSend = (id, data) => {
  const url = `${vendingbaseURL2()}/version/send/${id}`;
  return axios.post(url, data);
};

export const vendingVersionRemove = (id, data) => {
  const url = `${vendingbaseURL()}/version/remove/${id}`;
  return axios.post(url, data);
};
/* ===== END VENDING VERSION ===== */


/* ===== CATEGORY AI RULES ===== */
export const loadDRVMRecyclingCategory = data => {
  const url = `${APIHost()}/general/admin/express/drvmCategory/load`;
  return axios.post(url, data);
};

export const updateCategoryRules = (id, data) => {
  const url = `${APIHost()}/general/admin/express/drvmCategory/rules/${id}`;
  return axios.post(url, data);
};
/* ===== END CATEGORY AI RULES ===== */
